export default "__VITE_ASSET__2ca946e9__"